import axios from 'axios';
import { ADMIN_API_BASE, adminAuthConfig } from './api_admin';

const _err = (e) => { if (e.response) console.error('Admin verifications error:', e.response.status, e.response.data); };
const qs = (p) => {
    const s = new URLSearchParams();
    Object.entries(p || {}).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') s.append(k, v); });
    return s.toString();
};

export const verifError = (e, fb = 'Не удалось выполнить операцию') => e?.response?.data?.error || fb;

export const APIAdminVerifications = async (token, params = {}) => {
    try { const r = await axios.get(`${ADMIN_API_BASE}/verifications/?${qs(params)}`, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};
export const APIAdminVerificationDetail = async (token, id) => {
    try { const r = await axios.get(`${ADMIN_API_BASE}/verifications/${id}/`, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};
export const APIAdminVerificationApprove = async (token, id, note = '') => {
    try { const r = await axios.post(`${ADMIN_API_BASE}/verifications/${id}/approve/`, { note }, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};
export const APIAdminVerificationReject = async (token, id, reason) => {
    try { const r = await axios.post(`${ADMIN_API_BASE}/verifications/${id}/reject/`, { reason }, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};
export const APIAdminVerificationRequestChanges = async (token, id, note) => {
    try { const r = await axios.post(`${ADMIN_API_BASE}/verifications/${id}/request-changes/`, { note }, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};

// Риск-метки
export const APIAdminProfileRiskFlags = async (token, profileId) => {
    try { const r = await axios.get(`${ADMIN_API_BASE}/profiles/${profileId}/risk-flags/`, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};
export const APIAdminProfileRiskFlagAdd = async (token, profileId, flagType, note = '') => {
    try { const r = await axios.post(`${ADMIN_API_BASE}/profiles/${profileId}/risk-flags/add/`, { flag_type: flagType, note }, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};
export const APIAdminProfileRiskFlagRemove = async (token, profileId, flagType) => {
    try { const r = await axios.delete(`${ADMIN_API_BASE}/profiles/${profileId}/risk-flags/${flagType}/delete/`, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};